module.exports = __webpack_public_path__ + "img/quit_icon.8e454567.svg";